import { isIOS } from 'react-device-detect'
import { getTokenFCM } from './firebase'

const initNotifs = () => {
    if (!isIOS) {
        getTokenFCM()
    }
}

export { initNotifs }